import { themes } from 'kb-shared';
import styled from 'styled-components';

export const Text = styled.div`
  color: ${themes.colors.neutral.primaryNavy};
  font-size: 20px;
`;

export const ButtonContainer = styled.div`
  flex-flow: row;
  & > button {
    margin: 12px 12px 0 0;
  }
`;
